/* Nutty — pouzdan 'Dodaj u košaricu' (v4, 27.8.2026)

   Rjesava dvije stvari:

   1) Na PDP-u postoje DVA gumba s name="add": temin pravi submit gumb je
      sakriven inline stilom (display:none !important), a vidljivi je klon
      s type="button" koji sam po sebi ne submita formu.

   2) Klik na tekst gumba radi, klik par piksela dalje ne radi. Zato gumb
      trazimo u tri koraka: na gumbu → u njegovom wrapperu → geometrijski
      unutar okvira gumba.

   VAZNO (popravak v4): zona i geometrijski fallback moraju biti USKI.
   Nas izbornik 'Opcije kupovine' i temin quantity stepper zive unutar iste
   forme, pa je prethodna verzija gutala klik na radio 'Pretplata' i umjesto
   toga dodavala jednokratni paket. Sad se prije svega odbacuju klikovi na
   nase elemente, na drawer i na bilo koju drugu kontrolu (label, input,
   link, quantity). */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  window.NuttyAdd = window.NuttyAdd || {};

  var IGNORE = '.nutty-po, .nutty-pack, .nutty-empty, #w4root, [role="dialog"], dialog, .klaviyo-form';
  var CONTROLS = 'input, select, textarea, label, a, [role="button"], .quantity, quantity-input, [name="minus"], [name="plus"], [name="checkout"]';

  function visibleAddButtons() {
    return [].slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="add"]'))
      .filter(function (b) { return b.offsetParent; });
  }

  function buttonFromEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return null;

    /* nikad ne diraj nase elemente ni cart drawer */
    if (t.closest(IGNORE)) return null;

    /* 1. klik je na samom gumbu */
    var direct = t.closest('[name="add"]');
    if (direct) return direct;

    /* svaka druga kontrola u formi ostaje netaknuta (radio, quantity, linkovi) */
    if (t.closest(CONTROLS)) return null;

    /* 2. klik je u wrapperu samog gumba */
    var zone = t.closest('add-to-cart-component');
    if (zone) {
      var inZone = [].slice.call(zone.querySelectorAll('[name="add"]'));
      for (var i = 0; i < inZone.length; i++) { if (inZone[i].offsetParent) return inZone[i]; }
      if (inZone[0]) return inZone[0];
    }

    /* 3. klik je geometrijski unutar okvira vidljivog gumba */
    var btns = visibleAddButtons();
    for (var j = 0; j < btns.length; j++) {
      var r = btns[j].getBoundingClientRect();
      if (!r.width || !r.height) continue;
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) return btns[j];
    }
    return null;
  }

  function formData(form) {
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return null;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var props = {};
    [].forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
      if (el.type === 'checkbox' && !el.checked) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (m && el.value) props[m[1]] = el.value;
    });
    var item = { id: parseInt(id.value, 10), quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && sp.value) item.selling_plan = parseInt(sp.value, 10);
    return item;
  }

  function openDrawer() {
    ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
    });
    var icon = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"]');
    if (icon) icon.click();
  }

  document.addEventListener('click', function (e) {
    var btn = buttonFromEvent(e);
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    /* pretplatu na paketu rjesava nutty-pretplata.js (registriran ranije) */
    if (window.NuttyAdd.subscriptionActive && window.NuttyAdd.subscriptionActive(form)) return;

    var item = formData(form);
    if (!item) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    if (busy) return;
    busy = true;
    btn.style.opacity = '.6';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        busy = false; btn.style.opacity = '';
        if (!res.ok) { alert(res.j.description || 'Greška pri dodavanju u košaricu.'); return; }
        openDrawer();
      })
      .catch(function () {
        busy = false; btn.style.opacity = '';
        alert('Greška pri dodavanju u košaricu.');
      });
  }, true);
})();
